import SyncPage from './src/sync-page';

export default SyncPage;
